import React from "react";
import { useDispatch, useSelector } from "types/store";
import * as viewReducer from "containers/View/reducer";
import { Button, ButtonGroup, Icon } from "aible";
import { isEnabled } from "utils/featureFlags";
import Tooltip from "components/Inputs/Tooltip";
import styles from "./style.module.css";
import * as aibleAnywhereReducer from "containers/AibleAnywhere/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
const AgentAutonomyControls = ({ isDataView, style, history, isAgentPage }) => {
    const dispatch = useDispatch();
    const agentAutonomyView = useSelector((state) => viewReducer.getAgentAutonomyView(state));
    const agentAutonomyViewOptions = useSelector((state) => viewReducer.getAgentAutonomyViewOptions(state));
    const hideControls = !isEnabled("agent-autonomy-controls") || agentAutonomyViewOptions?.length < 1;
    if (hideControls) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: isDataView ? styles.agentAutonomyControlsWrapper + " " + styles.isDataView : styles.agentAutonomyControlsWrapper, style: style },
        React.createElement("div", { className: styles.agentAutonomyControls },
            React.createElement("div", { className: styles.agentAutonomyControlsLabel }, "Agent Autonomy"),
            React.createElement("div", { className: styles.agentAutonomyViewOptionsWrapper },
                React.createElement(ButtonGroup, null, agentAutonomyViewOptions.map((option) => {
                    return (React.createElement(AgentAutonomyViewOptionButton, { option: option, key: option?.value, currentView: agentAutonomyView, isAgentPage: isAgentPage, history: history }));
                }))))));
};
const AgentAutonomyViewOptionButton = ({ option, currentView, history, isAgentPage }) => {
    const dispatch = useDispatch();
    return (React.createElement(Tooltip, { trigger: option?.tooltip === undefined || option?.tooltip === "" ? ["none"] : ["hover"], overlay: React.createElement("div", { style: option?.tooltipStyle }, option?.tooltip) },
        React.createElement(Button, { onClick: () => {
                if (isAgentPage === true && history !== undefined && option?.value !== currentView) {
                    history.push("/");
                }
                if (option?.value === "LOW" || option?.value === "MODERATE") {
                    dispatch(aibleAnywhereReducer.resetNewAibleAnywhere());
                }
                if (option?.value === "HIGH") {
                    dispatch(chatGPTReducer.updateAgentIQTools(undefined));
                }
                dispatch(viewReducer.updateAgentAutonomyView(option?.value));
                dispatch(viewReducer.handleAgentAutonomyView(option?.value));
            }, active: currentView === option?.value, style: { minWidth: "110px" }, greyscaleDefaultState: true, disabled: option?.disabled },
            React.createElement(React.Fragment, null,
                option?.icon ? (React.createElement(Icon, { src: option?.disabled && option?.disabledIcon ? option.disabledIcon : option?.icon, size: 18, style: { marginRight: "4px" } })) : null,
                option?.label))));
};
export default AgentAutonomyControls;
